<script lang="ts">
  import { defineComponent } from 'vue';
  import Mixins from '@/helpers/mixins';
  import MainButton from '@/components/ui/buttons/MainButton.vue';
  import { StatusPopupTypes } from '@/helpers/enums';
  import PopupWrapper from '@/components/ui/outlets/PopupWrapper.vue';

  export default defineComponent({
    components: { PopupWrapper, MainButton },
    mixins: [Mixins],
    props: {
      popupStatus: { type: String as () => StatusPopupTypes, required: true },
      showPopup: { type: Boolean, default: true },
      confirmationButtonText: { type: String, default: null },
      cancelButtonText: { type: String, default: null },
    },
    emits: {
      confirm: () => true,
      cancel: () => true,
    },
  });
</script>

<template>
  <PopupWrapper :show-popup="showPopup">
    <div class="d-flex flex-column h-100 py-24 px-16 gap-16">
      <div class="d-flex flex-column flex-grow-1 align-items-center">
        <slot />
      </div>

      <div class="d-flex flex-column align-items-center gap-16 min-h-0">
        <img
          :alt="`${popupStatus} icon`"
          :src="imgUrl(`icons/popup_statuses/${popupStatus}.svg`)"
          class="min-h-0"
        />
        <div class="d-flex w-100 gap-16">
          <MainButton
            v-if="cancelButtonText"
            :type="$enums.ButtonTypes.secondary"
            class="flex-grow-1"
            @click="$emit('cancel')"
          >
            {{ cancelButtonText }}
          </MainButton>
          <MainButton
            v-if="confirmationButtonText"
            :type="$enums.ButtonTypes.primary"
            class="flex-grow-1"
            @click="$emit('confirm')"
          >
            {{ confirmationButtonText }}
          </MainButton>
        </div>
      </div>
    </div>
  </PopupWrapper>
</template>
